export default __webpack_public_path__ + "static/administation-1e2b2d9c6f1f975cce25f8fc0a342ec4.png";